export default {"src":"/_next/static/media/SafeGlobal.34325556.svg","height":36,"width":95,"blurWidth":0,"blurHeight":0};